import {ModifiedNucleotideAttributes} from 'constants/SequenceConstants';

// Keep in sync with SequenceMapPreviewJustify in benchling/modbio/bulk_edit_mods/types.py
export enum SequenceMapPreviewJustify {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  CUSTOM = 'CUSTOM',
}

export interface BulkEditModsError {
  message: string;
  retryable: boolean;
}

export interface BulkEditModsPreview {
  bases: string;
  modifiedNucleotides: Array<ModifiedNucleotideAttributes>;
  changedPositions: Array<number>;
}

export interface BulkEditModsResult {
  updatedId: string | null;
  preview: BulkEditModsPreview | null;
  error: BulkEditModsError | null;
}

export const MAX_NUM_BULK_EDIT_MODS_TARGETS = 100;
